export default __webpack_public_path__ + "static/media/BuyplanColumnSelection.89a5e64c.png";